module.exports = __webpack_public_path__ + "img/stationery_banner.041bd206.svg";